import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Instagram, Facebook, Youtube, MapPin, Phone, Mail, Clock } from "lucide-react";
import { CSLogo } from "@/components/CSLogo";
import { api } from "@/lib/api";

export const Footer = () => {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  return (
    <footer className="bg-[#111111] text-gray-300 mt-20" data-testid="site-footer">
      <div className="cs-container py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <CSLogo variant="light" className="h-10 w-32" />
          <p className="mt-5 text-sm text-gray-400 leading-relaxed">
            Premium certified pre-owned cars in Delhi NCR. Transparent pricing, inspected quality, and real after-sales support.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold text-white uppercase tracking-wider mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/buy" className="hover:text-white">Buy Cars</Link></li>
            <li><Link to="/sell" className="hover:text-white">Sell Your Car</Link></li>
            <li><Link to="/loans" className="hover:text-white">Car Loans</Link></li>
            <li><Link to="/certified" className="hover:text-white">CS Certified</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold text-white uppercase tracking-wider mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/reviews" className="hover:text-white">Reviews</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold text-white uppercase tracking-wider mb-4">Visit Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin size={16} className="shrink-0 mt-0.5 text-[#940C2C]" />{settings.address || "Vikaspuri, New Delhi"}</li>
            {settings.phone && <li className="flex gap-2"><Phone size={16} className="shrink-0 mt-0.5 text-[#940C2C]" />{settings.phone}</li>}
            <li className="flex gap-2"><Mail size={16} className="shrink-0 mt-0.5 text-[#940C2C]" />{settings.email || "carzswag@gmail.com"}</li>
            <li className="flex gap-2"><Clock size={16} className="shrink-0 mt-0.5 text-[#940C2C]" />{settings.business_hours || "Mon–Sun: 11 AM–7 PM"}</li>
          </ul>
          <div className="flex gap-3 mt-5">
            {settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm hover:text-white transition-colors" data-testid="footer-instagram-link">
                <span className="h-8 w-8 rounded-lg inline-flex items-center justify-center text-white" style={{ background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF)" }}><Instagram size={16} /></span>
                @{settings.instagram_handle || settings.instagram.replace(/\/+$/, "").split("/").pop()}
              </a>
            )}
            {settings.facebook && <a href={settings.facebook} target="_blank" rel="noreferrer" className="hover:text-white"><Facebook size={18} /></a>}
            {settings.youtube && <a href={settings.youtube} target="_blank" rel="noreferrer" className="hover:text-white"><Youtube size={18} /></a>}
          </div>
        </div>
      </div>

      <div className="border-t border-[#2A2A2A]">
        <div className="cs-container py-5 flex flex-col sm:flex-row justify-between text-xs text-gray-500 gap-2">
          <span>© {new Date().getFullYear()} CARZ SWAG. All rights reserved.</span>
          <span>Built for Delhi NCR • Pre-owned car marketplace</span>
        </div>
      </div>
    </footer>
  );
};
